<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Interne Seite auswählen
  section.modal-card-body
    b-table(:data="pages"
            default-sort-direction="asc"
            default-sort="createdAt"
            hoverable
            @click="row => selectMedia(row.id)")
      b-table-column(field='name' label='Name' sortable searchable v-slot="props")
        | {{props.row.name}}
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    pages() {
      return this.$store.state.blocks.all;
    }
  },
  methods: {
    selectMedia(id) {
      this.$emit("select", this.pages.find(m => m.id === id));
    }
  },
  mounted() {
    this.$store.dispatch("blocks/findAll");
  }
}
</script>

<style lang="scss" scoped>

</style>